<div class="w-full  bg-white border rounded-lg py-2">

    <div>
        <div role="tablist" class="tabs tabs-bordered px-3 capitalize">
            @for (i of tabs; track $index) {
                <a role="tab" (click)="currentTab = i.value" class="tab hover:rounded-t-md" [ngClass]="{'tab-active': currentTab == i.value}">{{i.name}}</a>
            }
          </div>
    </div>

    <div class="p-5">
        <div>
            <ng-container [ngSwitch]="currentTab">
                <app-video-content-graph *ngSwitchCase="'video-content'"></app-video-content-graph>
                <app-oral-test-graph *ngSwitchCase="'oral-test'"></app-oral-test-graph>
                <app-progress-test-graph *ngSwitchCase="'progress-test'"></app-progress-test-graph>
                <app-live-test-graph *ngSwitchCase="'live-test'"></app-live-test-graph>
            </ng-container>



        </div>
        <hr class="my-5">
        <div>
            <app-table-view [data]="tableData"></app-table-view>
        </div>
    </div>

</div>

<div class="my-5 grid grid-cols-2 gap-5">

    <div class="col-span-1 bg-white border rounded-lg">
       <div class="px-5 py-3">
        <p class="font-semibold">Achievements</p>
       </div>
       <hr>
       <div class="grid grid-cols-2 p-5 gap-2">
            <div class="flex flex-col items-center justify-center gap-2">
                <span class="font-semibold text-sm text-yellow-600">Conclave Dec 2024</span>
                <img class="w-full h-full object-contain " src="https://img.freepik.com/free-vector/trophy-award-laurel-wreath-composition-with-realistic-image-golden-cup-decorated-with-garland-with-reflection_1284-32301.jpg?t=st=1743410142~exp=1743413742~hmac=18adc5ab4c848db7e16b76ffe8886357a2982744af6a35adfff7ad2377863b2f&w=740" alt="">
            </div>
            <div class="flex flex-col items-center justify-center">
                <p class="text-9xl font-bold text-black">2</p>
                <p class="text-lg font-semibold">Rank</p>
                <p class="text-sm italic text-zinc-500">Won prize of 2000</p>   
            </div>
       </div>
    </div>

    <div class="col-span-1 bg-white border rounded-lg">
        <div class="px-5 py-3">
         <p class="font-semibold">Certicates</p>
        </div>
        <hr>
        <ul class="flex gap-5 overflow-x-auto p-5">
            @for (i of certifacates; track $index) {
                <li class="">
                    <img class="bg-slate-300 h-[12rem] max-w-[18rem] object-contain" src="{{i.img}}" alt="">
                    <p class="font-semibold line-clamp-1 mt-3">{{i.title}}</p>
                    <div class="flex justify-between items-center">
                        <p class="text-xs text-black capitalize font-semibold">{{i.issued_by}}</p>
                        <p class="text-xs text-zinc-500 uppercase">{{i.date_issued | date}}</p>
                    </div>
                </li>
            }
        </ul>
        
     </div>

</div>